import React, { useEffect, useState } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const SportsTravelBanner = ({ onLoad }) => {

 

  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
     
        <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/sports%20Travel.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={useHighRes ? handleImageLoad : undefined}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
        {imageLoaded && (
        <div className="ctm-text position-absolute text-white mt-md-3">
          <p className="fs4 text-uppercase busy grotesk-headings">
            SPORTS TRAVEL
          </p>
          <h1 className="banner-headings w-100">
            Advance Your Game with Our Sports Travel Solutions
          </h1>
          <div className="d-flex common-second-content">
            <div className="ornge-border"></div>
            <div className="second-content">
              Ready to take your team or event to the next level? From global
              tournaments to local matches, our expert sports travel logistics
              services ensure everything runs smoothly.
            </div>
          </div>
          </div>
          )}
        </div>
      )}
    </BannerWrapper>
  );
};

export default SportsTravelBanner;
